module.exports = __webpack_public_path__ + "img/nsi-logo.b532d4f4.png";